export enum CreatedInterface {
  Admin = 'adminInterface',
  Rider = 'riderInterface',
  RiderWeb = 'riderWebInterface',
  Driver = 'driverInterface',
  Ivr = 'ivrInterface',
  AiVoice = 'aiVoiceInterface',
  AiChat = 'aiChatInterface',
  OpenBooking = 'openBookingInterface',
}
